import React, { useState } from 'react';
// import video1 from './data/video1.mp4';
// import video2 from './data/video2.mp4';
// import video3 from './data/video3.mp4';

export const Video = () => {
  const videos = [null, null, null];

  // const [isPlaying, setIsPlaying] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [currentSlideAnimation, setCurrentSlideAnimation] = useState('none');
  const [currentVideo, setCurrentVideo] = useState({
    video: videos[0],
    index: 0,
  });

  // const playVideoHandler = e => {
  //   isPlaying ? e.target.pause() : e.target.play();
  //   setIsPlaying(curr => !curr);
  // };

  const previousVideo = () => {
    if (currentVideo.index === 0) {
      setCurrentVideo({
        video: videos[videos.length - 1],
        index: videos.length - 1,
      });
    } else {
      setCurrentVideo(curr => ({
        video: videos[curr.index - 1],
        index: curr.index - 1,
      }));
    }
    // setIsPlaying(false);
  };

  const nextVideo = () => {
    if (currentVideo.index === videos.length - 1) {
      setCurrentVideo({
        video: videos[0],
        index: 0,
      });
    } else {
      setCurrentVideo(curr => ({
        video: videos[curr.index + 1],
        index: curr.index + 1,
      }));
    }
    // setIsPlaying(false);
  };

  const changeSlideHandler = changeDirection => {
    setButtonsDisabled(true);
    setCurrentSlideAnimation('changeSlide 1s');
    const changeVideoPromise = new Promise((res, rej) => {
      setTimeout(() => {
        changeDirection === 'next' ? nextVideo() : previousVideo();
        res();
      }, 500);
    });

    changeVideoPromise.then(() => {
      setTimeout(() => {
        setCurrentSlideAnimation('none');
        setButtonsDisabled(false);
      }, 500);
    });
  };

  return (
    <div className="video" id="video">
      <div className="video-heading">
        <p>Відео</p>
      </div>
      <div className="video-slider">
        <div className="video-block">
          <div className="prev-video"></div>
        </div>
        <button
          className="prev-button slider-button desktop"
          onClick={() => changeSlideHandler('previous')}
          disabled={buttonsDisabled}
        >
          <i className="fas fa-angle-double-left"></i>
        </button>
        <div className="current-video-block video-block">
          <video
            src={currentVideo.video}
            className="current-video slide"
            // onClick={playVideoHandler}
            title="Натисніть, щоб відтворити або призупинити"
            style={{
              animation: currentSlideAnimation,
            }}
            controls
          ></video>
          <div className="mobile-controls">
            <button
              className="prev-button slider-button"
              onClick={() => changeSlideHandler('previous')}
              disabled={buttonsDisabled}
            >
              <i className="fas fa-angle-double-left"></i>
            </button>
            <button
              className="next-button slider-button"
              onClick={() => changeSlideHandler('next')}
              disabled={buttonsDisabled}
            >
              <i className="fas fa-angle-double-right"></i>
            </button>
          </div>
        </div>
        <button
          className="next-button slider-button desktop"
          onClick={() => changeSlideHandler('next')}
          disabled={buttonsDisabled}
        >
          <i className="fas fa-angle-double-right"></i>
        </button>
        <div className="video-block">
          <div className="next-video"></div>
        </div>
      </div>
    </div>
  );
};
